module.exports = __webpack_public_path__ + "static/img/2023_9_8_8.ef9eacb5.ef9eacb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/2023_9_8_8.ef9eacb5.png
// module id = GOaE
// module chunks = 0